import styles from './ContactBlock.module.scss';

interface Props {
  children: React.ReactNode;
}

const ContactBlock: React.FC<Props> = ({ children }) => (
  <div className={styles.contactBlock}>{children}</div>
);

export default ContactBlock;
